import React from 'react'
import 'styles/index.styl'
import { BaseProvider } from 'contexts/BaseContext'
import { ENV } from 'gatsby-env-variables'

if (ENV === 'prod') {
  Promise.resolve(
    import(
      /* webpackChunkName: "newRelic" */ './src/infra/newRelic.js'
    ),
  ).then(res => {
    res.default()
    console.log('NewRelic scripts loaded!')
  })
}

export const wrapRootElement = ({ element }) => {
  return <BaseProvider>{element}</BaseProvider>
}
